import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowProducedType,
} from 'flow-schema';
import { z } from 'zod';

import { SubFlowV2BlockConfigSchema } from '../../subFlow/v2/config.js';

export const SkillV2BlockConfigSchema = SubFlowV2BlockConfigSchema;

export type SkillV2BlockConfig = z.infer<typeof SkillV2BlockConfigSchema>;

export const SkillV2BlockBaseSchema = z.object({
  type: z.literal(FlowBlockType.SkillV2),
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
  config: SkillV2BlockConfigSchema,
});
export type SkillV2BlockBase = z.infer<typeof SkillV2BlockBaseSchema>;

export const SkillV2BlockSchema = BaseFlowBlockSchema.merge(SkillV2BlockBaseSchema);

export type SkillV2Block = z.infer<typeof SkillV2BlockSchema>;
